<template>
  <el-popover
    placement="bottom"
    v-model="showModal"
    popper-class="body-popover"
    trigger="manual"
  >
    <div class="popover">
      <div class="bulk-form">
        <div class="title">Time Zone</div>
        <div class="right-container">
          <el-select
            ref="tz2"
            v-model="form.tzName"
            clearable
            filterable
            placeholder="None"
          >
            <el-option
              v-for="item in timezones"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="click-icon"></div>
      </div>
      <div class="bulk-form">
        <div class="title">Post Time</div>
        <div class="right-container">
          <hi-datetime
            :clear-able="false"
            v-model="form.postTime"
            @focus="postTimeFocus"
          ></hi-datetime>
        </div>
        <div class="click-icon"></div>
      </div>
      <!-- <div class="bulk-form" v-if="!facebookGroup">
        <div class="title">Delete Time</div>
        <div class="right-container">
          <hi-datetime v-model="form.deleteTime" :readonly="!autoDeletePermission" @itemClick="delClick"
                       @focus="delTimeFocus"></hi-datetime>
        </div>
        <div class="click-icon"></div>
      </div> -->
      <div class="bottom-container">
        <hi-button @click="cancelClick" type="text" class="bulk-btn"
          >Cancel</hi-button
        >
        <hi-button @click="confirmClick" type="text" class="bulk-btn"
          >Done</hi-button
        >
      </div>
    </div>
    <div slot="reference">
      <div
        class="bulk-time-item"
        :class="{ open: showModal, lock: bulkType === 1 }"
        @click="show"
      >
        <div class="text" v-if="val.postTime">{{ text }}</div>
        <div class="text empty" v-else>Add Time</div>
        <div class="icon" v-show="bulkType !== 1"></div>
      </div>
    </div>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.popover {
  padding: 5px 0;

  .bulk-form {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    width: 300px;
    font-size: 14px !important;
    line-height: 1 !important;

    .title {
      font-size: 14px;
    }

    .right-container {
      flex: 1;
      justify-content: flex-end;
      margin-left: 10px;
      text-align: right;
    }

    .click-icon {
      width: 8px;
      height: 14px;
      background-image: url("../../../../../public/images/schedule_posts/Date_Right@3x.png");
      background-size: contain;
      margin-left: 5px;
      position: relative;
      top: 1px;
      filter: grayscale(100%);
      opacity: 0.3;
    }
  }
  .bottom-container {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;
    border-top: 1px solid @border-color;
    height: 50px;
    align-items: center;
    .bulk-btn {
      padding: 0;
      font-size: 16px;
      line-height: 1;
    }
  }
}

.bulk-time-item {
  width: 135px;
  height: 36px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  cursor: pointer;
  &.lock {
    background: #f5f5f5;
    cursor: default;
  }
  .text {
    font-size: 14px;
    color: black;
    flex: 1;

    &.empty {
      color: @font-color-gray;
    }
  }
  .icon {
    width: 15px;
    height: 15px;
    background-position: center;
    background-size: contain;
    background-image: url(../../../../../public/images/bulk/Rectangle_gray_1@3x.png);
    background-repeat: no-repeat;
  }
  &.open {
    border-color: @theme-color;
    .text {
      color: @theme-color;
    }
    .icon {
      background-image: url(../../../../../public/images/bulk/Rectangle_red_2@3x.png);
    }
  }
}
</style>

<script>
import { timezones } from "../../../../const/timezone";
import hiDatetime from "../../../common/form/DateTime";
import moment from "moment-timezone";
import hiButton from "../../../common/button/Index";
import _ from "lodash";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";
import { mapGetters } from "vuex";
import { permissionValidate } from "../../../../service/publisher";

export default {
  name: "BulkTimeComponent",
  components: { hiDatetime, hiButton },
  props: {
    val: {
      type: Object,
      required: true,
    },
    bulkType: {
      // bulk 类型 0:自定义 1 default time 2 bulk time
      type: Number,
      required: true,
    },
    formatTimezone: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      first: false, // 是否刚被设置过值
      timezones,
      dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
      form: {},
    };
  },
  computed: {
    ...mapGetters({
      publisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    facebookGroup() {
      return this.publisher.socialNetwork === 3;
    },
    /**
     * 自动删除权限
     */
    autoDeletePermission() {
      return this.permission.auto_delete;
    },
    /**
     * 日期组件显示的文案
     */
    text() {
      let text = "";
      if (this.val.postTime) {
        text += moment
          .tz(this.val.postTime, this.val.tzName)
          .tz(this.formatTimezone)
          .format("HH:mm");
      }
      if (this.val.deleteTime) {
        text += ` → ${moment
          .tz(this.val.deleteTime, this.val.tzName)
          .tz(this.formatTimezone)
          .format("HH:mm")}`;
      }
      return text;
    },
  },
  watch: {
    val: {
      handler(val) {
        this.first = true;
        this.form = _.cloneDeep(val);
      },
      deep: true,
      immediate: true,
    },
    showModal(val) {
      if (val) {
        this.first = false;
      }
    },
    /**
     * 监听时区变化，动态更新post time 和delete time
     */
    "form.tzName"(val, old) {
      if (this.first || !old) {
        this.first = false;
        return;
      }
      // 时区变化更新post time 和 delete time
      if (this.form.deleteTime) {
        this.form.deleteTime = moment
          .tz(this.form.deleteTime, old)
          .tz(val)
          .format(this.dateTimeFormat);
      }
      if (this.form.postTime) {
        this.form.postTime = moment
          .tz(this.form.postTime, old)
          .tz(val)
          .format(this.dateTimeFormat);
      }
    },
    /**
     * 监听post time变化
     */
    "form.postTime"(val) {
      // 当前选中的删除时间
      const delDateTime = moment(this.form.deleteTime);
      const postDateTime = moment(val);
      // 如果发送时间比删除时间还晚则自动更新删除时间
      if (moment(delDateTime).isBefore(postDateTime)) {
        // 在posttime时间基础上加5分钟
        this.form.deleteTime = moment(val)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
    },
    "$route.query"(val, old) {
      this.showModal = false;
    },
  },
  methods: {
    /**
     * 删除按钮点击事件 用于验证是是否有delete time 权限
     */
    async delClick() {
      if (!this.autoDeletePermission) {
        await permissionValidate({ type: "full" });
      }
    },
    show() {
      this.showModal = this.bulkType !== 1;
    },
    /**
     * 确认按钮点击事件
     */
    confirmClick() {
      const form = _.cloneDeep(this.form);
      this.$emit("confirm", form);
      this.showModal = false;
    },
    cancelClick() {
      this.$set(this, "form", _.cloneDeep(this.val));
      this.showModal = false;
    },
    /**
     * post time 如果没设置，则自动设置时间
     */
    postTimeFocus() {
      if (!this.form.postTime) {
        this.form.postTime = moment()
          .tz(this.form.tzName)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
    },
    /**
     * 删除时间焦点事件
     */
    delTimeFocus() {
      if (this.form.deleteTime === "" || !this.form.deleteTime) {
        this.form.deleteTime = moment
          .tz(this.form.postTime, this.form.tzName)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
    },
  },
};
</script>
